module.exports = __webpack_public_path__ + "img/Grafic (1).7555e102.jpg";